export default __webpack_public_path__ + "static/blob-50-1bdcf67d8bbba960d7c8076e83c1fc87.svg";